import { render, staticRenderFns } from "./UserDetailScreen.vue?vue&type=template&id=c8680e0e&scoped=true&"
import script from "./UserDetailScreen.vue?vue&type=script&lang=js&"
export * from "./UserDetailScreen.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailScreen.vue?vue&type=style&index=0&id=c8680e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8680e0e",
  null
  
)

component.options.__file = "UserDetailScreen.vue"
export default component.exports